import { Box, Button, Form, TextInput, Image, Anchor } from "grommet";
import React, { useEffect } from "react";

import axios from "../general/HttpClient";
import { Route, Routes, useNavigate } from "react-router-dom";
import { SignalRContext } from "./Admin";
import Login from "./Login";
import Subject from "./Subject";
import Mirror from "./Mirror";

const Home = () => {
    const [showControls, setShowControls] = React.useState(true);

    useEffect(() => {
        setTimeout(() => {
            setShowControls(false);
        }, 5000);
    }, []);

    return (
        <SignalRContext.Provider url={"/deviceHub"}>
            {showControls && (
                <div>
                    <Anchor href="/admin">Admin</Anchor>
                </div>
            )}
            <Routes>
                <Route path="/" element={<Mirror />}></Route>
            </Routes>
        </SignalRContext.Provider>
    );
};

export default Home;
